export default "__VITE_ASSET__CGa2aYhH__"